import { DASHBOARD, EL_DASHBOARD, NEWSFEED } from 'routes/constants';

import {
  ELEMENTARY_MODE_KEY,
  GUARDIAN_MODE_KEY,
  MIDDLE_HIGH_SCHOOL_MODE_KEY,
} from 'modules/AccountSetupV2/widgets/K12DashboardSwitcher/constants';

const dashboardRedirect = ({ redirect }) =>
  redirect({
    to: DASHBOARD,
    component: 'modules/CounselorDashboard',
    reason: 'Navigate user to dashboard if we do not have a current user mode',
  });

const elDashboardRedirect = ({ redirect }) =>
  redirect({
    to: EL_DASHBOARD,
    component: 'modules/ElementaryStaffDashboard',
    reason:
      'Navigate user to elementary dashboard if @currentUserMode="elementary"',
  });

const newsfeedRedirect = ({ redirect }) =>
  redirect({
    to: NEWSFEED,
    component: 'modules/Newsfeed',
    reason:
      'Navigate user to guardian newsfeed if @currentUserMode="elementary"',
  });

export default {
  [MIDDLE_HIGH_SCHOOL_MODE_KEY]: dashboardRedirect,
  [GUARDIAN_MODE_KEY]: newsfeedRedirect,
  [ELEMENTARY_MODE_KEY]: elDashboardRedirect,
};
